import { ref, watch } from 'vue'

const STORAGE_KEY = 'eventSearch.groupMode'
const VALID_MODES = ['logtype', 'source']

export const DEFAULT_GROUP_MODE = 'logtype'

// The mode also travels in the URL (?group=), so callers assigning from an
// untrusted source must validate — the persistence watcher below writes back
// whatever it is given.
export function isValidGroupMode(mode) {
  return VALID_MODES.includes(mode)
}

function load() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored && isValidGroupMode(stored)) return stored
  } catch {
    // Ignore storage errors
  }
  return DEFAULT_GROUP_MODE
}

const groupMode = ref(load())

watch(groupMode, (mode) => {
  try {
    localStorage.setItem(STORAGE_KEY, mode)
  } catch {
    // Ignore storage errors
  }
})

export function useGroupMode() {
  return { groupMode }
}
